import httpService from "./httpService";
import { apiUrl } from "./config.json";

let apiEndpoint = "";
if (process.env.NODE_ENV !== "production") {
  apiEndpoint = `${apiUrl}/newbucket`;
} else {
  apiEndpoint = `${apiUrl}/newbucket`;
}

export async function uploadPdfFile(file) {
  const formData = new FormData();
  formData.append('file', file);

  for (let pair of formData.entries()) {
    console.log(pair[0] + ':', pair[1]);
  }

  const response = await httpService.postForm(`${apiEndpoint}/getPdfCont`, formData);
  // const response = await httpService.postForm(`https://api.contractpro360.com/api/newbucket/getPdfCont`, formData);

  return response;
}
